'use strict';

exports = module.exports = require('./dist')['default'];
exports['default'] = exports;



/*****************
 ** WEBPACK FOOTER
 ** ./~/intl-format-cache/index.js
 ** module id = 1029
 ** module chunks = 1
 **/